import type {TextProps} from '@smart/web-components';
import {RichText, Text} from '@smart/web-components';
import * as React from 'react';
import styles from './payment-details.module.scss';
import type {RichtextLinkProps} from './richtext-link';
import {RichtextLink} from './richtext-link';

export interface PaymentDetailsProps {
  readonly text: string;
}

interface CustomOverride<TProps> {
  readonly component: React.ComponentType<TProps>;
  readonly props: Partial<TProps>;
}

const headingOverride: CustomOverride<TextProps> = {
  component: Text,
  props: {
    variant: `label-100`,
    className: styles.heading,
  },
};

const paragraphOverride: CustomOverride<TextProps> = {
  component: Text,
  props: {
    variant: `caption-200`,
    className: styles.paragraph,
  },
};

const anchorOverride: CustomOverride<RichtextLinkProps> = {
  component: RichtextLink,
  props: {
    variant: `hyperlink-100`,
    className: styles.link,
  },
};

export const PaymentDetails = React.memo(({text}: PaymentDetailsProps) => (
  <RichText
    className={styles.paymentDetails}
    mdString={text}
    customOverrides={{
      h1: headingOverride,
      h2: headingOverride,
      h3: headingOverride,
      h4: headingOverride,
      h5: headingOverride,
      h6: headingOverride,
      p: paragraphOverride,
      a: anchorOverride,
    }}
  />
));
